"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cortona": {
    "434bcb1d": [{
      "hkey": "5e985d6c",
      "slug": "camucia-monsigliolo",
      "name": "Camucia-Monsigliolo",
      "primary": true,
      "skipSearch": false
    }],
    "camucia": [{
      "hkey": "5e985d6c",
      "slug": "camucia-monsigliolo",
      "name": "Camucia-Monsigliolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "28c6cba8": [{
      "hkey": "23a3e07c",
      "slug": "fratticciola",
      "name": "Fratticciola",
      "primary": true,
      "skipSearch": false
    }],
    "fraticciola": [{
      "hkey": "23a3e07c",
      "slug": "fratticciola",
      "name": "Fratticciola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "792da4ac": [{
      "hkey": "5e985d6c",
      "slug": "camucia-monsigliolo",
      "name": "Camucia-Monsigliolo",
      "primary": true,
      "skipSearch": false
    }],
    "monsigliolo": [{
      "hkey": "5e985d6c",
      "slug": "camucia-monsigliolo",
      "name": "Camucia-Monsigliolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cortona"
    }],
    "14663fc9": [{
      "hkey": "2ba9ee41",
      "slug": "terontola",
      "name": "Terontola",
      "primary": true,
      "skipSearch": false
    }],
    "terontola-stazione": [{
      "hkey": "2ba9ee41",
      "slug": "terontola",
      "name": "Terontola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "4ea73180": [{
      "hkey": "025a6f63",
      "slug": "toppo-di-moro",
      "name": "Toppo di Moro",
      "primary": true,
      "skipSearch": false
    }],
    "toppo-di-morro": [{
      "hkey": "025a6f63",
      "slug": "toppo-di-moro",
      "name": "Toppo di Moro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;